import React, { Component } from "react";
import RenderFormField from "./RenderFormField";
import { Row, Col } from "react-bootstrap";
import "./form-field.style.scss";
import { yesNoOptions } from "./constants";
import RenderFormFieldView from "./RenderFormFieldView";

export default class CustomerInfoCor extends Component {
  render() {
    const RenderCom = this.props.isView ? RenderFormFieldView : RenderFormField;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="FormTitle">Customer Information</p>
          </Col>
        </Row>
        <Row>
          {customerInformationFields.map((field) => (
            <Col key={field.name} xs={12} md={field.fullWidth ? 12 : 6}>
              <RenderCom {...field} formValues={this.props.formValues} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}
const customerInformationFields = [
  {
    name: "business_purpose_loan_flag",
    type: "dropdown",
    label: "Does customer have business purpose loan?",
    options: yesNoOptions,
  },
  {
    name: "customers_loan_has_collateral_flag",
    type: "dropdown",
    label: "Does customer's loan have collateral?",
    options: yesNoOptions,
  },
  {
    name: "customer_id",
    type: "input",
    label: "Customer ID",
  },
  {
    name: "customer_name",
    type: "input",
    label: "Customer Name",
  },
  {
    name: "customer_industry",
    type: "input",
    label: "Customer Industry",
  },
  {
    name: "number_of_employees",
    type: "input-number",
    label: "Number of employees",
  },
  {
    name: "revenue",
    type: "input-number",
    label: "Revenue",
  },
  {
    name: "total_assets",
    type: "input-number",
    label: "Total Assets",
  },
  {
    name: "date_of_establishment",
    type: "datePicker",
    label: "Date of establishment",
  },
  {
    name: "address",
    type: "input",
    label: "Address",
  },
  {
    name: "business_license_investment_license_number",
    type: "input",
    label: "Business License / Investment License Number",
  },
  {
    name: "tax_code",
    type: "input",
    label: "Tax Code",
  },
  {
    name: "financial_statement_date",
    type: "datePicker",
    label: "Financial Statement Date",
  },
  {
    type: "space",
    fullWidth: true,
    height: "1px",
  },
  {
    name: "historical_rating_rating_date",
    type: "datePicker",
    label: "Latest rating date",
  },
  {
    name: "historical_rating_rm_id",
    type: "input",
    label: "RM ID",
  },
  {
    name: "historical_rating_branch",
    type: "input",
    label: "Branch",
  },
  {
    name: "historical_rating_rating_id",
    type: "input",
    label: "Rating ID",
  },
  {
    name: "historical_rating_latest_rating",
    type: "input",
    label: "Customer's latest rating",
  },
];



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/CustomerInfoCor.js